import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title = 'Avenis Global | Brand Partnerships & Wholesale Solutions',
    description = 'Avenis Global specializes in e-commerce partnerships, wholesale solutions, and digital marketing strategies. Partner with us for Amazon wholesale, brand partnerships, and comprehensive digital solutions.',
    keywords = 'Amazon wholesale, e-commerce partnerships, brand partnerships, wholesale solutions, digital marketing, Amazon seller, wholesale business, e-commerce consulting, brand management, digital solutions',
    image = '/logo-512x512.png',
    url = 'https://avenisglobal.com',
    type = 'website',
    structuredData = null,
}) => {
    const fullTitle = title.includes('Avenis Global')
        ? title
        : `${title} | Avenis Global`;
    const fullImage = image.startsWith('http') ? image : `${url}${image}`;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="title" content={fullTitle} />
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content="Avenis Global" />
            <meta name="robots" content="index, follow" />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="7 days" />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={fullImage} />
            <meta property="og:image:width" content="512" />
            <meta property="og:image:height" content="512" />
            <meta property="og:site_name" content="Avenis Global" />
            <meta property="og:locale" content="en_US" />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={fullImage} />

            {/* Canonical URL */}
            <link rel="canonical" href={url} />

            {/* Structured Data */}
            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
